import { IElement } from "core-integration/src/store/elements/types";
import Link from "plos/src/components/links/Link";
import { SurfaceContainer } from "plos/src/components/SurfaceContainer";
import { integerToMoneyWithCurrency } from "plos/src/utils/money";
import { useTranslation } from "react-i18next";
import { ChevronRight } from "../../../icons/Chevrons";
import { PriceChangeStatus } from "../../../PriceChanges/PriceChangeStatus";
import { getPriceChangeStatus } from "../../../PriceChanges/utils";
import styles from "./PriceChangeSummary.module.css";

interface PriceChangeSummaryProps {
  element: IElement;
}

const PriceChangeSummary = ({ element }: PriceChangeSummaryProps) => {
  const { t } = useTranslation("priceChanges");

  const priceChangeStatus = getPriceChangeStatus(element);
  const isPriceChangeLocked = Boolean(element.price_change_locked_until);

  return (
    <SurfaceContainer>
      <div className={styles.wrapper}>
        <div className={styles.priceSection}>
          <span>
            {t("price", "Price")}:{" "}
            <strong>{integerToMoneyWithCurrency(element.now_cost, 10)}</strong>
          </span>
          {/* Don't show the price change status if the value is 3 (Unlikely to change) unless it's locked */}
          {(priceChangeStatus !== 3 || isPriceChangeLocked) && (
            <PriceChangeStatus element={element} />
          )}
        </div>
        <Link className={styles.link} to="/price-changes">
          {t("viewPriceChanges", "View all Price Predictions")}
          <ChevronRight />
        </Link>
      </div>
    </SurfaceContainer>
  );
};

export default PriceChangeSummary;
